/**
 * 客户回款，银行确认单 详情页面配置
 * @author zjs
 * @time 2017-10-26
 */
export default {
    data () {
        return {
            infoConfig : [
                {"label":"流水号","prop":"transaction_no_display"},
                {"label":"交易日期","prop":"trade_time"},
                {"label":"交易行名","prop":"trade_name"},
                {"label":"银行账户名称","prop":"account_name"},
                {"label":"收支金额","prop":"amount"},
                {"label":"银行账号","prop":"account_number"},
                {"label":"交易渠道","prop":"trade_channel"},
                {"label":"交易往来","prop":"trade_transact"},
                {"label":"交易方式","prop":"trade_way"},
                {"label":"对方信息","prop":"duifangxinxi"},
                {"label":"交易说明","prop":"trade_remark"},
                {"label":"制单人","prop":"clerk_name"},
                {"label":"业务日期","prop":"business_time"}
            ] // 详情信息的配置
        }
    }
}